const _excluded = ["children", "className", "disabled", "display", "focused", "ghost", "hovered", "invalid", "padding", "radius", "size", "width"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'clsx';
import { AlignTarget } from "../Align";
import { PressableCore } from "./";

const PressableField = props => {
  const getColor = () => {
    const {
      disabled,
      hovered
    } = props;

    if (disabled) {
      return 'disabled';
    }

    return hovered ? 'hover' : 'default';
  };

  const getCursor = () => {
    const {
      disabled
    } = props;
    return disabled ? 'default' : 'text';
  };

  const getFill = () => {
    const {
      disabled,
      ghost
    } = props;
    const fillColor = disabled ? 'disabled' : 'base';
    return ghost ? 'none' : fillColor;
  };

  const getFontLineHeight = () => {
    const {
      size
    } = props;

    if (size === 'jumbo') {
      return 28;
    } else if (size === 'large') {
      return 20;
    } else if (size === 'small') {
      return 16;
    }

    return 20;
  };

  const getFontSize = () => {
    const {
      size
    } = props;

    if (size === 'small') {
      return 13;
    } else if (size === 'jumbo') {
      return 16;
    }

    return 14;
  };

  const getKeyline = () => {
    const {
      disabled,
      ghost,
      invalid
    } = props;
    const keylineColor = !disabled && invalid ? 'negative' : 'base';
    return ghost ? 'none' : {
      color: keylineColor,
      side: 'all',
      width: 1
    };
  };

  const getPadding = () => {
    const {
      padding,
      size
    } = props;

    if (padding) {
      return padding;
    } else if (size === 'jumbo') {
      return {
        horizontal: 16,
        vertical: 8
      };
    } else if (size === 'large') {
      return {
        horizontal: 12,
        vertical: 8
      };
    }

    return {
      horizontal: 8,
      vertical: 4
    };
  };

  const getShadow = () => {
    const {
      disabled,
      focused,
      ghost
    } = props;
    return ghost ? {
      focused: !disabled && focused
    } : {
      base: true,
      focused: !disabled && focused
    };
  };

  const {
    children,
    className,
    disabled,
    display,
    focused,
    ghost,
    hovered,
    invalid,
    padding,
    radius,
    size,
    width
  } = props,
        remaining = _objectWithoutProperties(props, _excluded);

  const classes = classNames('PressableField', className);
  return /*#__PURE__*/React.createElement(AlignTarget, {
    lineHeight: getFontLineHeight(),
    nestable: true,
    size: getFontSize(),
    strategy: "center" // @ts-expect-error - TS2769 - No overload matches this call.
    ,
    padding: getPadding()
  }, alignProps =>
  /*#__PURE__*/
  // $FlowFixMe - go/flowfixme122
  React.createElement(PressableCore, _extends({}, alignProps, remaining, {
    className: classes,
    color: getColor(),
    cursor: getCursor(),
    display: display,
    fill: getFill(),
    fontLineHeight: getFontLineHeight(),
    fontSize: getFontSize(),
    height: size // @ts-expect-error - TS2322 - Type '"none" | { color: string; side: string; width: number; }' is not assignable to type '"none" | PressableCoreKeylineMap | undefined'.
    ,
    keyline: getKeyline() // @ts-expect-error - TS2322 - Type 'SpacingMap | { horizontal: number; vertical: number; }' is not assignable to type 'SpacingMap | undefined'.
    ,
    padding: getPadding(),
    radius: radius,
    shadow: getShadow(),
    width: width
  }), children));
};

PressableField.defaultProps = {
  disabled: false,
  display: 'inline-flex',
  focused: false,
  ghost: false,
  hovered: false,
  invalid: false,
  radius: 'all',
  size: 'medium',
  width: 'auto'
};
export default PressableField;